<template>
  <div>   
     <Menu/>
      <router-view />
    </div>
  
</template>

<script>

import Menu from "./components/Menu.vue";


export default {
  name: "App",
  components: {
   Menu
  
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  
  margin-top: 1px;
}
</style>
